import { get, post, postJson } from "./common"

/**
 * 获取时间
 */
export function getTime() {
	return new Promise((resolve, reject) => {
		get("/getNowTime")
			.then(res => {
				resolve(res)
			})
			.catch(e => {
				console.log(e)
				reject(e)
			})
	})
}

/**
 * 获取利率
 */
export function getRates(list) {
	return new Promise((resolve, reject) => {
		let _url = "/interface/fund/multiFundInfo/",
			_fundStr = "",
			_timeStr = ""
		for (let i = 0; i < list.length; i++) {
			_fundStr += `|${list[i].fundCode}`
			_timeStr += `|${list[i].desc}`
		}
		get(`${_url}${_fundStr}_${_timeStr}`).then(res => {
			if (res.error && res.error.id === 0) {
				resolve(res.data)
			} else {
				reject(res.error.msg)
			}
		})
	})
}

export function fetchIndexAll() {
	return new Promise((resolve, reject) => {
		post("/hqapi/marketEvaluate/queryAll")
			.then(res => {
				if (res.status_code === 0) {
					resolve(res.data)
				} else {
					reject(res.status_msg)
				}
			})
			.catch(e => {
				console.log(e)
				reject(e)
			})
	})
}
export function fetchIndexDetail(obj = {}) {
	return new Promise((resolve, reject) => {
		post("/hqapi/marketEvaluate/queryDetail", obj)
			.then(res => {
				if (res.status_code === 0) {
					resolve(res.data)
				} else {
					reject(res.status_msg)
				}
			})
			.catch(e => {
				console.log(e)
				reject(e)
			})
	})
}

export function getFundDetail(code) {
	return new Promise((resolve, reject) => {
		get(`/interface/fund/multiFundInfo/${code}`)
			.then(res => {
				resolve(res)
			})
			.catch(e => {
				console.log(e)
				reject(e)
			})
	})
}

export function fetchOuterFund(trackCode, uniqueId) {
	return postJson(
		"/marketing/common_rank/fund/track/single",
		{
			trackList: [trackCode],
			uniqueId
		}
	).then(res => {
		if (res.status_code === 0) {
			const { showName: fundName, showCode: fundCode, show } = (res.data || [])[0] || {};
			return {
				show,
				fundName,
				fundCode
			}
		} else {
			throw new Error(res.status_msg);
		}
	})
}

export function fetchConfig(code) {
	return get("/hqapi/static/hq/commonconfig/kvdatasave/marketEvaluate").then(res => {
		if (res.status_code === 0) {
			const resData =  JSON.parse(res.data || '{}');
			const rankList = resData.rank || [];
			return rankList.find(item => item.fundCode === code) || {};
		} else {
			throw new Error(res.status_msg);
		}
	})
}

export function fetchInnerFund(marketid, thscodeHq, uniqueId) {
	return postJson("/marketing/common_rank/track/single", {
		indexList: [`${marketid}_${thscodeHq}`],
		uniqueId
	}).then(res => {
		if (res.status_code === 0) {
			const { showName: fundName, showCode: fundCode, show } = (res.data || [])[0] || {};
			return {
				show,
				fundName,
				fundCode
			}
		} else {
			throw new Error(res.status_msg);
		}
	})
}
